import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PayPalReturn() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [error, setError] = useState(null);
  const orderId = params.get("order_id");
  const token = params.get("token"); // PayPal appends this

  useEffect(() => {
    if (!orderId) { setError("Missing order id"); return; }
    (async () => {
      try {
        await api.get("/checkout/paypal/capture", { params: { order_id: orderId, token } });
        nav(`/order/success?session_id=paypal_${orderId}&order_id=${orderId}`, { replace: true });
      } catch (e) { setError(e.response?.data?.detail || "Capture failed"); }
    })();
  }, [orderId, token, nav]);

  return (
    <div className="max-w-md mx-auto py-24 text-center">
      {error ? (
        <>
          <XCircle className="h-10 w-10 text-destructive mx-auto mb-4" />
          <h1 className="font-display text-2xl font-bold mb-2">Payment could not be captured</h1>
          <p className="text-muted-foreground text-sm">{error}</p>
        </>
      ) : (
        <>
          <Loader2 className="h-10 w-10 animate-spin text-primary mx-auto mb-4" />
          <h1 className="font-display text-2xl font-bold">Confirming your PayPal payment…</h1>
        </>
      )}
    </div>
  );
}
